module.exports = __webpack_public_path__ + "img/blora.faedfd4b.jpg";